"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Diamond = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Diamond_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.817 13.693 3.876-3.876c.453-.453.75-.752.96-.998.2-.237.261-.36.287-.439a1.23 1.23 0 0 0 0-.76c-.026-.08-.086-.202-.288-.44-.209-.245-.506-.544-.96-.997L9.818 2.307c-.453-.453-.752-.75-.998-.96-.237-.2-.36-.261-.439-.287a1.231 1.231 0 0 0-.76 0c-.08.026-.202.086-.44.288-.245.209-.544.506-.997.96L2.307 6.182c-.453.453-.75.752-.96.998-.2.237-.261.36-.287.439-.08.247-.08.513 0 .76.026.08.086.202.288.44.209.245.506.544.96.997l3.875 3.876c.453.453.752.75.998.96.237.2.36.261.439.287.247.08.513.08.76 0 .08-.026.202-.086.44-.288.245-.209.544-.506.997-.96Zm.707.707 3.876-3.876c.883-.883 1.325-1.325 1.49-1.835a2.23 2.23 0 0 0 0-1.378c-.165-.51-.607-.952-1.49-1.835L10.524 1.6C9.641.716 9.2.275 8.69.11a2.231 2.231 0 0 0-1.378 0C6.8.274 6.359.715 5.476 1.6L1.6 5.476C.716 6.359.275 6.8.11 7.31c-.146.448-.146.93 0 1.378.165.51.606.952 1.49 1.835L5.476 14.4c.883.883 1.325 1.325 1.835 1.49.448.146.93.146 1.378 0 .51-.165.952-.607 1.835-1.49Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Diamond_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Diamond;
exports["default"] = _default;